<template>
  <div class="demographic-data-no-access mt-9">
    <DpplSvg file-name="demographic-data-no-access" class="mb-8" />
    <h2 class="new-h2 mb-4">
      We weren't able to find any demographic data for your candidates.
    </h2>
    <p class="new-body-text no-data-text mb-4">
      Our data suggests that you are not collecting, or not
      sharing demographic data with Datapeople.<br /><br />

      If you believe this is incorrect, please reach out to
      your Datapeople Customer Success representative.
    </p>
    <DpplNewButton
      color="brandPrimary"
      target="_blank"
      href="mailto:support@datapeople.io?subject=Demographic%20Survey%20Report%20Inquiry"
      rel="noopener noreferrer"
    >
      Contact Us
    </DpplNewButton>
  </div>
</template>

<script setup>
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
</script>

<style scoped lang="less">
.demographic-data-no-access {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .no-data-text {
    color: @text-light;
    text-align: center;
    max-width: 850px;
  }

  h2.new-h2 {
    font-size: 23px;
  }

  p.new-body-text {
    font-size: 16px;
    font-weight: 400;
  }

  :deep(.dppl-button.v-btn) {
    font-size: 16px;
  }
}
</style>
